import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/**
 * @typedef {import('react-reconciler').Fiber} Fiber
 */

/**
 * @param {Fiber} instance
 */

export function getPropsForInstance(instance) {
  /**
   * @type {Fiber['pendingProps']}
   */
  var props = {};
  Object.entries(instance.memoizedProps).forEach(function (_ref) {
    var _instance$type$defaul;
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var type = typeof value;

    // Ignore some values, even if they're scalar, because they're not unique enough
    if (['key'].includes(key) || value === ((_instance$type$defaul = instance.type.defaultProps) === null || _instance$type$defaul === void 0 ? void 0 : _instance$type$defaul[key])) {
      return;
    }

    // Scalar values
    if (['string', 'number', 'boolean', 'symbol'].includes(type) || value instanceof String || value instanceof Number || value instanceof Boolean || value instanceof Symbol) {
      props[key] = value;
    }
  });
  return props;
}